import React, { useMemo } from 'react'
import { useWarehouseContext } from 'utils/contexts/warehouse/WarehouseContext.hooks'

const FRENCH_LOCALE_CODES = ['fr_CA']

/**
 * Injects the useI18n prop to the given component.
 */
export const withDepartmentsAndAislesI18nSupport = (Component: React.ComponentClass<any>) => {
  return (props: any) => {
    const { warehouse } = useWarehouseContext()

    const useI18n = useMemo(
      () => warehouse.locales.some(locale => FRENCH_LOCALE_CODES.includes(locale.localeCode)),
      [warehouse]
    )

    return <Component useI18n={useI18n} {...props} />
  }
}
